import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderLiveBranchEntity } from '@/features/trackOrder/domain/entities/orderEntities/OrderLiveBranchEntity'
import type { MonitorOrderBranchAdminDto } from '@/backend/market'

export class OrderLiveBranchModel extends OrderLiveBranchEntity {
  constructor(dataDto: MonitorOrderBranchAdminDto) {
    super()
    mapEntityProperties<OrderLiveBranchEntity>(this, dataDto)
  }
}
